export const majorVersion = 1;
export const minorVersion = 1;
export const patchVersion = 183;

export const buildNumber = 278;

export const VERSION = `${majorVersion}.${minorVersion}.${patchVersion}.${buildNumber}`;
export const VERSION_WITHOUT_BUILD = `${majorVersion}.${minorVersion}.${patchVersion}`;

